"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var useConfigurableStyle_1 = require("../_utils/useConfigurableStyle");
var hooks_1 = require("../../hooks");
var CollapsibleListCard = function (_a) {
    var className = _a.className, overrideDefaultClassName = _a.overrideDefaultClassName, header = _a.header, defaultIsCollapsed = _a.defaultIsCollapsed, headerBackgroundColor = _a.headerBackgroundColor, showLessText = _a.showLessText, showMoreText = _a.showMoreText, children = _a.children, props = __rest(_a, ["className", "overrideDefaultClassName", "header", "defaultIsCollapsed", "headerBackgroundColor", "showLessText", "showMoreText", "children"]);
    var _b = hooks_1.useToggle(typeof defaultIsCollapsed === "boolean" ? defaultIsCollapsed : true), isCollapsed = _b[0], toggleIsCollapsed = _b[1];
    var _c = useConfigurableStyle_1.useConfigurableStyle({
        defaultClassName: {
            "collapsible-list-card": !isCollapsed,
            "collapsible-list-card--collapsed": isCollapsed
        },
        additionalClassName: className,
        overrideDefaultClassName: overrideDefaultClassName,
        styleProp: props.style
    }), finalClassName = _c[0], style = _c[1];
    var _d = useConfigurableStyle_1.useConfigurableStyle({
        defaultClassName: "collapsible-list-card__header",
        backgroundColor: headerBackgroundColor
    }), headerClassName = _d[0], headerStyle = _d[1];
    var _e = useConfigurableStyle_1.useConfigurableStyle({
        defaultClassName: "collapsible-list-card__toggle__text",
        backgroundColor: headerBackgroundColor
    }), toggleClassName = _e[0], toggleStyle = _e[1];
    return (react_1.default.createElement("div", __assign({ className: finalClassName, style: style }, props),
        react_1.default.createElement("div", { className: headerClassName, style: headerStyle }, header || null),
        react_1.default.createElement("div", { className: "collapsible-list-card__content" },
            react_1.default.createElement("div", { className: "collapsible-list-card__toggle" },
                react_1.default.createElement("div", { className: toggleClassName, style: toggleStyle, onClick: toggleIsCollapsed }, isCollapsed ? showMoreText || "Show More" : showLessText || "Show Less")),
            children)));
};
CollapsibleListCard.defaultProps = {
    defaultIsCollapsed: true,
};
exports.default = CollapsibleListCard;
